import React, { useEffect } from "react";
import {ShowableProductCard} from "ReactApp/Ddd/Aggregates/ShowableProductCard";
import IconV1 from "ReactApp/Components/IconV1/IconV1";

type AddToCompareV1Props = {
    productCard: ShowableProductCard
}

const AddToCompareV1 = ({ productCard }: AddToCompareV1Props) => {

    const { currentProductConfig } = productCard;

    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }
    let uniqueKey = currentProductConfig.getUniqueId();

    useEffect(() => {
        window?.widgets?.addToCompareV1?.checkSelected();
    }, [uniqueKey]);

    return (
        <div className="icon-button heart add-to-compare-v1" key={uniqueKey}
            add-to-compare-v1=""
            data-add-to-compare-v1-is-in-compare="0"
            data-add-to-compare-v1-product-type-id={currentProductConfig.productTypeId}
            data-add-to-compare-v1-id={currentProductConfig.id}
            data-add-to-compare-v1-virtual-modifier-id={currentProductConfig.virtualModifierId ?? ""}>
            <IconV1 {...{
                svgSpriteId: 'equalizer-v2',
                width: 20,
                height: 20,
                classes: [
                ]
            }} />
        </div>
    );
}

export { AddToCompareV1 };